<template>
  <b-modal
    size="lg"
    title="Elija un Recurso"
    :id="id"
    class="cme-modal modal-recursos"
    :ref="id"
    hide-footer
    @hidden="close"
  >
    <b-container fluid v-if="flagSearch">
      <NavContent :view-blocks="false" v-on:styleList="onSelectStyleList($event)">
        <template v-slot:tituloCabecera>Mis recursos</template>
      </NavContent>
      <filtro-recursos
        :show-filter="showFilter"
        :disable-type="true"
        v-on:filter="targetFilter"
        v-on:reset="resetFiltro"
      />
      <b-col style="text-align: right; margin-bottom:30px;">
         <b-button variant="primary" v-b-modal.modal-upload-files>
          <font-awesome-icon icon="plus" />&nbsp; Subir Nuevo Recurso
        </b-button>
      </b-col>
      <!--<slot v-if="typeViewList == 'block'">
        <b-row>
          <b-card-group columns id="block-view-container" class="pb-5">
            <BlockContent
              v-for="r in listRecursos"
              :key="r._id"
              :record="r"
              :buttons="buttonsBlock"
              v-on:btnClicked="onClickButton($event)"
              class="cards"
              @dataCheckedRecursos="checkedRecursos($event)"
            >
              <img
                v-if="r.type == 'IMAGEN'"
                :src="$root.setUrlFile(r.file)"
                class="video-preview"
                :alt="r.file"
              />
              <audio v-else-if="r.type == 'AUDIO'" class="audio-preview" controls autobuffer>
                <source :src="$root.setUrlFile(r.file)" />
              </audio>
              <video v-else class="video-preview" controls>
                <source :src="$root.setUrlFile(r.file)" />
              </video>
            </BlockContent>
          </b-card-group>

          <b-card-group columns id="block-view-container" class="pb-5">
            <BlockContent
              v-for="r in listRecursos"
              :header-name="r.file"
              :key="r._id"
              :record="r"
              :buttons="[]"
              :card-button="true"
              v-on:cardCliked="insertarRecurso(r)"
            >
              <img
                v-if="r.type == 'IMAGEN'"
                :src="$root.setUrlFile(r.file)"
                class="img-preview"
                :alt="r.file"
              />
              <audio v-else-if="r.type == 'AUDIO'" class="audio-preview" controls autoplay="false">
                <source :src="$root.setUrlFile(r.file)" />
              </audio>
              <video v-else class="video-preview" :src="$root.setUrlFile(r.file)">
                <source :src="$root.setUrlFile(r.file)" />
              </video>
            </BlockContent>
          </b-card-group>
        </b-row>
      </slot>-->
      <slot v-if="typeViewList == 'list'">
        <TableContent
          v-on:row-clicked="insertarRecurso($event)"
          :table-data="listRecursos"
          :fields="tableFields"
          :per-page="dataPagination.limit"
          :show-pagination="false"
        />
      </slot>
      <b-pagination
        class="paginador-cme"
        v-on:change="getListRecursos($event)"
        :total-rows="dataPagination.totalDocs"
        :per-page="dataPagination.limit"
        v-model="dataPagination.page"
        prev-text="Anterior"
        next-text="Siguiente"
        hide-goto-end-buttons
      />
    </b-container>
    <b-container v-else class="pt-2 pb-3">      
      <b-col class="text-center mt-3">
        <h3>¿Algún Tema en Especial?</h3>
        <b-input-group>
          <b-form-input
            v-model.trim="wordSearch"
            type="text"
            v-on:keyup=" ($event) => { $event.key == 'Enter' ? getListRecursos(1): false }"
          ></b-form-input>
          <b-input-group-append>
            <b-button @click="getListRecursos(1)" variant="primary">
              <font-awesome-icon icon="search" />
            </b-button>
          </b-input-group-append>
        </b-input-group>
        <b-button class="mt-2" variant="link" @click="getListRecursos(1)">
          <p style="font-size: 1rem;">Mostrar Todo el Contenido</p>
        </b-button>
      </b-col>
    </b-container>
    <modal-upload-files @onSuccessFiles="resetFiltro"></modal-upload-files>
  </b-modal>
</template>

<script>
//import cTable from "@/components/TableContent";
import TableContent from "@/components/TableContent";
import NavContent from "@/components/NavContent";
import BlockContent from "@/components/BlockContent";
import FiltroRecursos from "@/components/FiltroRecursos";
import RecursoService from "@/services/recurso.service";
import ModalUploadFiles from "@/components/ModalUploadFiles";

export default {
  name: "ModalRecursos",
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    typeRecurso: {
      type: String,
      default: null
    },
    id: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      listRecursos: [],
      dataPagination: {
        page: 1,
        limit: 5,
        totalDocs: 0
        /*totalPages: 0*/
      },
      paramsList: {
        paginate: true,
        filtro: { type: this.typeRecurso }
      },
      tableFields: [
        { key: "file", label: "Recurso" },
        { key: "tags", label: "Tags" },
        {
          key: "fechaUltimaActualizacion",
          label: "Última actualización",
          sortable: true
        }
      ],
      recurso: null,
      elemento: null,
      typeViewList: "list",
      showFilter: false,
      flagSearch: false,
      wordSearch: "",
      user: this.$store.getters["auth/infoUser"],
      buttonsBlock: []
    };
  },
  watch: {
    typeRecurso: function(data) {
      console.log(data);
      this.paramsList.filtro.type = data;
    },
    showModal: function(data) {
      if (data) {
        //this.getListRecursos(1);
        this.$refs[this.id].show();
        console.log(this.id);
      }
    }
  },
  components: {
    //cTable
    TableContent,
    NavContent,
    FiltroRecursos,
    BlockContent,
    ModalUploadFiles
  },
  methods: {
    close() {
      this.flagSearch = false;
      this.$emit("closeModal", false);
    },

    targetFilter(e) {
      if (e.wordSearch) this.wordSearch = e.wordSearch;
      //if(e.type) this.paramsList.filtro.type = e.type;
      this.getListRecursos(1);
    },
    resetFiltro() {    
      this.wordSearch = "";
      delete this.paramsList.filtro["tags"];      
      this.getListRecursos(1);
    },
    getListRecursos(page) {
      this.listRecursos = [];
      this.paramsList.filtro["$or"] = [
        { author: this.user._id },
        { compartido: { $in: [this.user._id] } }
      ];
      if (this.wordSearch) {
        this.paramsList.filtro["tags"] = {
          $regex: `.*${this.wordSearch}.*`,
          $options: "i"
        };
      }

      RecursoService.list(page, this.paramsList)
        .then(response => {
          //console.log(response);
          this.flagSearch = true;
          this.arrayBlockElements = new Array();
          this.dataPagination = JSON.parse(JSON.stringify(response));
          delete this.dataPagination.docs;
          this.listRecursos = response.docs;
          console.log(this.listRecursos);
        })
        .catch(err => console.error(err));

      //console.log(this.paramsList);
      /*this.listRecursos = [];
      if(this.wordSearch) 
        this.paramsList.filtro['tags'] = { "$regex": `.*${this.wordSearch}.*`, "$options": "i" }
      this.paramsList.filtro["$or"] = [
        { "author": this.$store.getters['auth/infoUser']._id}, 
        { "compartido": { "$in": [ this.$store.getters['auth/infoUser']._id ] } } 
      ];

      console.log("Estos params: ", this.paramsList, this.$store.getters['auth/infoUser'])
      RecursoService.list(page, this.paramsList)
        .then(response => {
          this.flagSearch = true;
          this.dataPagination = JSON.parse(JSON.stringify(response));
          delete this.dataPagination.docs;
          this.listRecursos = response.docs;
        })
        .catch(err => console.error(err));*/
    },
    insertarRecurso(e) {
      this.$emit("data-selected", e);
      this.$refs[this.id].hide();
    },
    closeModalBtn() {
      this.$emit("closeModal", false);
    },
    onSelectStyleList(e) {
      if (e == "filter") this.showFilter = !this.showFilter;
      else this.typeViewList = e;
    },
    getRowCount: function() {
      return this.arrayBlockElements.length;
    },
  },
  computed: {
    totalPages: function() {
      return this.getRowCount();
    }
  }
};
</script>
<style lang="scss">
.modal-recursos .modal-dialog {
  max-width: 80vw !important;
}

.btn-card {
  cursor: pointer;

  &:hover {
    border-color: #63c2de;
  }
}
</style>